import styled from '@emotion/styled';

import { DESKTOP } from '@/styles/themes';
import { fontAritaBuri } from '@/styles/themes/variables';

export const Wrapper = styled.section`
  color: #e4e4e4;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 20px;
  ${DESKTOP} {
    font-size: 24px;
  }
`;

export const Certificate = styled.div`
  position: relative;
  width: 328px;
  height: 232px;
  color: black;
  font-family: ${fontAritaBuri};
  ${DESKTOP} {
    width: 430px;
    height: 304px;
  }
`;

export const CertificateText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Name = styled.span`
  z-index: 10;
  margin: 74px 0 5px 0;
  font-size: 11px;
  font-weight: 700;
  ${DESKTOP} {
    margin: 96px 0 8px 0;
  }
`;

export const Desc = styled.p`
  z-index: 10;
  font-size: 9px;
  font-weight: 500;
  text-align: center;
  margin-top: 5px;
`;

export const GraduateDate = styled.div`
  z-index: 10;
  font-size: 9px;
  font-weight: 500;
  margin: 0 14px 0 78px;
  position: relative;
  top: 6%;
  ${DESKTOP} {
    top: 13%;
    margin: 0 25px 0 107px;
  }
`;

export const SaveButton = styled.button`
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 4px;
  background-color: #697583;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  margin-top: 24px;
  cursor: pointer;
  color: #e4e4e4;
  &:disabled {
    background-color: #434951;
    cursor: not-allowed;
  }
  ${DESKTOP} {
    height: 54px;
    font-size: 18px;
  }
`;

export const DownloadImg = styled.div`
  position: relative;
  margin-left: 8px;
  width: 18px;
  height: 18px;
  ${DESKTOP} {
    width: 20px;
    height: 20px;
  }
`;
